export default "__VITE_ASSET__BgmApl0U__"